import React from 'react'

import { Currency, Percent, Price } from '../../../sdk'
import { Field } from '../../../state/mint/actions'
import { ONE_BIPS } from '../../../constants'

export function PoolPriceBar({
  currencies,
  noLiquidity,
  poolTokenPercentage,
  price
}: {
  currencies: { [field in Field]?: Currency }
  noLiquidity?: boolean
  poolTokenPercentage?: Percent
  price?: Price
}) {
  return (
    <div className="flex justify-around gap-2 text-sm">
      <div className="text-center">
        <div className="font-mono tabular-nums">{price?.toSignificant(6) ?? '-'}</div>
        <div className="text-[10px] text-muted-foreground mt-0.5">
          {currencies[Field.CURRENCY_B]?.symbol} per {currencies[Field.CURRENCY_A]?.symbol}
        </div>
      </div>
      <div className="text-center">
        <div className="font-mono tabular-nums">{price?.invert()?.toSignificant(6) ?? '-'}</div>
        <div className="text-[10px] text-muted-foreground mt-0.5">
          {currencies[Field.CURRENCY_A]?.symbol} per {currencies[Field.CURRENCY_B]?.symbol}
        </div>
      </div>
      <div className="text-center">
        <div className="font-mono tabular-nums">
          {noLiquidity && price
            ? '100'
            : (poolTokenPercentage?.lessThan(ONE_BIPS) ? '<0.01' : poolTokenPercentage?.toFixed(2)) ?? '0'}
          %
        </div>
        <div className="text-[10px] text-muted-foreground mt-0.5">Share of Pool</div>
      </div>
    </div>
  )
}
